import { useCallback } from "react";
import { useMutation } from "react-apollo";
import { CREATE_TRIP_TYPE } from "./queries";
import useErrorHandling from "hooks/useErrorHandling";

const useCreateTripType = () => {
  const [update] = useMutation(CREATE_TRIP_TYPE);
  const withErrorHandling = useErrorHandling();

  const createTripType = useCallback(
    async (variables: {
      trip_type: string;
      display_name: string;
      description: string;
      start_state: string;
    }) => {
      withErrorHandling(update, {
        variables,
      });
    },
    [update, withErrorHandling]
  );

  return createTripType;
};

export default useCreateTripType;
